import { render, staticRenderFns } from "./account_edit.vue?vue&type=template&id=2e63ef74&"
import script from "./account_edit.vue?vue&type=script&lang=ts&"
export * from "./account_edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports